"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var cross_fetch_1 = require("cross-fetch");

var CachableRequest_1 = require("./CachableRequest");

var MockDataRequest_1 = require("./MockDataRequest");

var DEFAULT_AUTH_MODE = ksys_app_template_1.models.api.common.AuthenticationMode.header;

var KsysRequest =
/** @class */
function () {
  function KsysRequest(token, options, endpointsConfiguration) {
    this.token = token;
    this.endpointsConfiguration = endpointsConfiguration;
    this.options = this.orchestrateOptions(options);
  }

  KsysRequest.prototype.orchestrateOptions = function (overrideOptions) {
    var rootOptions = this.endpointsConfiguration && this.endpointsConfiguration.defaultEndpointConfiguration || {};
    var endpointOptions = this.endpointConfiguration || {};
    return ksys_app_template_1.utils.object.deepMergeObjectsWithOptions({}, rootOptions, endpointOptions, overrideOptions || {});
  };

  KsysRequest.prototype.getEndpointConfiguration = function (pillar, endpoint) {
    if (this.endpointsConfiguration && this.endpointsConfiguration.endpoints && this.endpointsConfiguration.endpoints[pillar]) {
      return this.endpointsConfiguration.endpoints[pillar][endpoint];
    }

    return {
      authenticationMode: DEFAULT_AUTH_MODE
    };
  };

  KsysRequest.prototype.getEndpoint = function (overrideOptions) {
    var options = ksys_app_template_1.utils.object.deepMergeObjects(this.options, overrideOptions);
    var endpoint = options.endpoint,
        urlParams = options.urlParams,
        queryString = options.queryString,
        placeholders = options.placeholders;
    var response = endpoint || this.getExplicitEndpoint();

    if (response && placeholders) {
      response = ksys_app_template_1.utils.replacePlaceholders(placeholders, response);
    }

    if (response && urlParams) {
      var join = response.endsWith('/') ? '' : '/';
      var cleanUrlParams = urlParams.map(function (urlParam) {
        return encodeURIComponent(urlParam);
      });
      response = "" + response + join + cleanUrlParams.join('/');
    }

    if (response && queryString) {
      var join = response.includes('?') ? '&' : '?';
      var queryStringPieces = Object.keys(queryString).reduce(function (acc, key) {
        var value = queryString[key];
        acc.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
        return acc;
      }, []);
      response = "" + response + join + queryStringPieces.join('&');
    }

    return response;
  };

  KsysRequest.prototype.getUrl = function (overrideOptions) {
    var options = ksys_app_template_1.utils.object.deepMergeObjects(this.options, overrideOptions);
    var baseUrl = options.baseUrl,
        explicitUrl = options.explicitUrl;

    if (explicitUrl) {
      return explicitUrl;
    }

    var endpoint = this.getEndpoint(overrideOptions);
    var separator = '/';
    var rawPieces = [baseUrl, endpoint];
    var pieces = rawPieces.map(function (piece, index) {
      var response = piece;

      if (index !== 0 && response.startsWith(separator)) {
        response = response.substr(separator.length);
      }

      if (index !== rawPieces.length - 1 && response.endsWith(separator)) {
        response = response.substr(0, response.length - separator.length);
      }

      return response;
    });
    var fullUrl = pieces.join(separator); // Check if GET and append token to queryString

    if (options.method === 'GET') {
      if (options.authenticationMode === ksys_app_template_1.models.api.common.AuthenticationMode.header) {
        var token = this.token.value;
        var querySeparator = fullUrl.indexOf('?') > -1 ? '&' : '?';
        fullUrl += querySeparator + "token=" + token;
      }

      if (options.disableCache) {
        fullUrl += "&_dc=" + Date.now();
      }
    }

    return fullUrl;
  };

  KsysRequest.prototype.execute = function (overrideOptions) {
    return __awaiter(this, void 0, void 0, function () {
      var response, options, mockDataRequest, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            options = ksys_app_template_1.utils.object.deepMergeObjects(this.options, overrideOptions);
            if (!(options && options.mockData && options.mockData.enabled)) return [3
            /*break*/
            , 1];
            mockDataRequest = new MockDataRequest_1.MockDataRequest(this.getUrl(overrideOptions), options);
            response = mockDataRequest.fetch();
            return [3
            /*break*/
            , 4];

          case 1:
            _a = this.handleResponse;
            return [4
            /*yield*/
            , this.callApi(overrideOptions)];

          case 2:
            return [4
            /*yield*/
            , _a.apply(this, [_b.sent(), overrideOptions])];

          case 3:
            response = _b.sent();
            _b.label = 4;

          case 4:
            if (this.orchestrateResponse) {
              response = this.orchestrateResponse(response);
            }

            return [2
            /*return*/
            , response];
        }
      });
    });
  };

  KsysRequest.prototype.callApi = function (overrideOptions) {
    return __awaiter(this, void 0, void 0, function () {
      var options, explicitMethod, _a, method, _b, headers, _c, body, _d, authenticationMode, tokenKey, request, url, cachableRequest, error_1;

      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            options = ksys_app_template_1.utils.object.deepMergeObjects(this.options, overrideOptions);
            explicitMethod = this.getExplicitMethod ? this.getExplicitMethod() : 'POST';
            _a = options.method, method = _a === void 0 ? explicitMethod : _a, _b = options.headers, headers = _b === void 0 ? {} : _b, _c = options.body, body = _c === void 0 ? {} : _c, _d = options.authenticationMode, authenticationMode = _d === void 0 ? DEFAULT_AUTH_MODE : _d;
            tokenKey = 'X-KSYS-TOKEN';

            if (authenticationMode === ksys_app_template_1.models.api.common.AuthenticationMode.header && this.token && this.token.value && !headers[tokenKey]) {
              headers[tokenKey] = this.token.value;
            }

            if (options.debug) {
              headers['X-KSYS-DEBUG'] = 'true';
            }

            if (options.fetchUserCountry) {
              if (options.debug) {
                console.info('Fetching user country code...');
              }

              headers['X-KSYS-COUNTRY'] = '1';
            }

            if (options.disableCache) {
              headers['cache-control'] = 'no-cache';
              headers['pragma'] = 'no-cache';
            }

            request = {
              method: method,
              credentials: 'same-origin',
              headers: __assign({
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }, headers),
              body: JSON.stringify(body)
            };

            if (method.toUpperCase() === 'GET') {
              delete request.body;
            }

            _e.label = 1;

          case 1:
            _e.trys.push([1, 5,, 6]);

            url = this.getUrl(overrideOptions);
            if (!options.disableCachableRequests) return [3
            /*break*/
            , 3];

            if (options.debug) {
              console.info('cache disabled, fetching response');
            }

            return [4
            /*yield*/
            , cross_fetch_1.fetch(url, request)];

          case 2:
            return [2
            /*return*/
            , _e.sent()];

          case 3:
            cachableRequest = new CachableRequest_1.CachableRequest(url, request, options.debug);
            return [4
            /*yield*/
            , cachableRequest.fetch()];

          case 4:
            return [2
            /*return*/
            , _e.sent()];

          case 5:
            error_1 = _e.sent();
            console.warn('request error', error_1);
            return [3
            /*break*/
            , 6];

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  KsysRequest.prototype.handleResponse = function (response, overrideOptions) {
    return __awaiter(this, void 0, void 0, function () {
      var options, rawContentType, rawContentTypeList, contentType, countryCode, responseType, responseBody, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            options = ksys_app_template_1.utils.object.deepMergeObjects(this.options, overrideOptions);
            rawContentType = response.headers.get('content-type') || '';
            rawContentTypeList = rawContentType.split(';');
            contentType = rawContentTypeList.length > 0 ? rawContentTypeList[0] : ''; // extract user country onto the window object, as we do not expose response headers via the API Client.

            if (options.fetchUserCountry && response.headers.has('X-KSYS-COUNTRY')) {
              countryCode = response.headers.get('X-KSYS-COUNTRY');

              if (options.debug) {
                console.info('User Country Code', countryCode);
              }

              if (window) {
                window[ksys_app_template_1.constants.GLOBAL_USER_COUNTRY_KEY] = countryCode;
              }
            }

            if (options.debug) {
              console.log('response content type', contentType);

              if (response.headers.has('X-KSYS-DEBUG')) {
                console.info('cloudflare debug', response.headers.get('X-KSYS-DEBUG'));
              }
            }
            /**
             * Change response type for other content types
             *
             * Common Mime type reference https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
             */


            switch (contentType) {
              case '':
                responseType = null;
                break;

              case 'application/json':
                responseType = 'json';
                break;

              case 'text/plain':
              case 'text/html':
                responseType = 'text';
                break;

              case 'text/csv':
              case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
              case 'application/msword':
              case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
              case 'application/pdf':
              case 'application/zip':
              case 'image/png':
              case 'image/jpeg':
              case 'image/gif':
              case 'image/svg+xml':
                responseType = 'blob';
                break;

              default:
                responseType = 'buffer';
            } // Return a blank if the response is a 204


            if (response.status === 204) {
              return [2
              /*return*/
              , ''];
            }

            if (!responseType) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , response[responseType]()];

          case 1:
            _a = _b.sent();
            return [3
            /*break*/
            , 3];

          case 2:
            _a = response;
            _b.label = 3;

          case 3:
            responseBody = _a; // Throw an exception for responses in the 400 range

            if (response.status >= 400 && response.status < 500) {
              throw Error(response.status + ":\n" + JSON.stringify(responseBody));
            } // Throw an error for responses not in the 200 range


            if (!response.ok) {
              throw Error(response.statusText);
            } // If everything is ok return the response body


            return [2
            /*return*/
            , responseBody];
        }
      });
    });
  };

  return KsysRequest;
}();

exports.KsysRequest = KsysRequest;